// @flow
import React, { Fragment } from "react";
import styled from "styled-components";
import Link from "../Link";
import Expander from "../Expander";
import DataFieldSearch from "./DataFieldSearch";
import { AddCircleOutline } from "styled-icons/material/AddCircleOutline";
import { fetchDataFieldNames } from "./Utils/DataFieldNamesFetch";

const DataFieldAdder = styled.div`
  display: inline-block;
  margin-right: 15px;
  padding-top: 3px;
  padding-bottom: 3px;
  color: #5d9cec;
  cursor: pointer;
  &:hover {
    color: #556375;
  }
`;

type Props = {
  onSubmit: () => void,
  company_id: ?number,
  company_branch_id: ?number,
};

type State = {
  showing: boolean,
  data_field_names: Array<DataFieldNameSearch>,
  active_data_field_names: Array<DataFieldNameSearch>,
};

type DataFieldNameSearch = {
  id: number,
  name: string,
  has_items: boolean,
};

export default class DataFieldFilter extends React.Component<Props, State> {
  dataFieldSearchRefs: Array<DataFieldSearch>;

  state = {
    showing: false,
    data_field_names: [],
    loaded: false,
    active_data_field_names: [],
  };

  queryParams = () =>
    this.dataFieldSearchRefs.filter((search) => search).map((search) => search.params());

  fetchData = () => {
    const { company_id, company_branch_id } = this.props;
    fetchDataFieldNames({ company_id, company_branch_id }).then((json) => {
      this.setState({
        loaded: true,
        active_data_field_names: [],
        data_field_names: json.data_field_names,
      });
    });
  };

  componentDidUpdate(prevProps) {
    // You don't have to do this check first, but it can help prevent an unneeded render
    if (this.state.showing) {
      if (prevProps.company_branch_id !== this.props.company_branch_id) {
        this.fetchData();
        return;
      }
      if (!this.state.loaded) {
        this.fetchData();
        return;
      }
    }
  }

  click = (data_field_name: DataFieldNameSearch) => {
    this.setState({
      active_data_field_names: this.state.active_data_field_names.concat(data_field_name),
    });
  };

  removeDataFieldSearch = (index: number) => {
    this.setState({
      active_data_field_names: this.state.active_data_field_names.filter(
        (_, i) => i !== index
      ),
    });
  };

  render() {
    this.dataFieldSearchRefs = [];
    const { company_id, onSubmit } = this.props;
    const { showing, active_data_field_names, data_field_names, loaded } = this.state;

    return (
      <div style={{ paddingTop: 0, paddingBottom: 10 }}>
        <Link onClick={() => this.setState({ showing: !showing })}>
          <Expander expanded={showing} />
          Search custom sample attributes...
        </Link>

        {active_data_field_names.map((data_field_name, i) => (
          <DataFieldSearch
            key={data_field_name.id}
            onSubmit={onSubmit}
            ref={(ref) => (this.dataFieldSearchRefs[i] = ref)}
            data_field_name={data_field_name}
            company_id={company_id}
            onDelete={() => this.removeDataFieldSearch(i)}
          />
        ))}

        <div>
          {showing &&
            !loaded && (
              <p>
                <i className="fa fa-spinner fa-spin" />
                &nbsp;Loading...
              </p>
            )}
          {showing &&
            data_field_names.map((data_field_name, i) => (
              <DataFieldAdder
                key={data_field_name.id}
                onClick={() => this.click(data_field_name)}
              >
                <AddCircleOutline size={18} />
                &nbsp;
                {data_field_name.name}
              </DataFieldAdder>
            ))}
        </div>
      </div>
    );
  }
}

export type { DataFieldNameSearch };
